import { render, staticRenderFns } from "./PageGender.vue?vue&type=template&id=77f8cc8e"
import script from "./PageGender.vue?vue&type=script&lang=js"
export * from "./PageGender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports